import MOptionButton from './MOptionButton.vue';

MOptionButton.install = (app) => {
  app.component('MOptionButton', MOptionButton);
};

export { MOptionButton };
